import { Text, View } from '@react-pdf/renderer';
import { isEmpty } from 'lodash-es';

import { IInvoicePdf } from '../../types/IInvoicePdf';
import { InvoiceTemplate } from '../InvoiceTemplateForm';

import styles from './Styles';

export const OrganizationEntity = ({
  invoice,
  template,
}: {
  invoice: IInvoicePdf;
  template?: InvoiceTemplate;
}) => {
  const showEntityName = template?.organizationEntityName ?? true;
  const showEntityAddress = template?.organizationEntityAddress ?? true;
  const showEntityLegal = template?.organizationEntityLegal ?? true;
  return (
    <View style={styles.half_section}>
      {(showEntityAddress || showEntityName || showEntityLegal) && (
        <>
          <Text style={styles.subTitle}>Billed By: </Text>
          {showEntityName && (
            <Text style={styles.subTitle_plain}>{invoice.ourEntity.Legal_Name}</Text>
          )}
          {showEntityAddress && (
            <Text style={styles.text}>{invoice.ourEntity.Registered_address}</Text>
          )}
          {!isEmpty(showEntityLegal) &&
            showEntityLegal &&
            invoice?.ourEntityLegalIdentifier?.map((legalValue, index) => (
              <Text style={styles.text} key={index}>
                {`${legalValue.legalIdentifierName ?? ''} : ` + `${legalValue.value ?? ''}`}
              </Text>
            ))}
        </>
      )}
    </View>
  );
};
